/**
 * Tema y plantillas visuales.  (spec 043)
 *
 * El catálogo se crece aquí: nombre + tokens en CSS. Las pantallas leen
 * variables, no un color suelto. No reordena menús ni bloques (FR-008).
 */
export const TEMAS = ['auto', 'dark', 'light'] as const
export type Tema = (typeof TEMAS)[number]
export type TemaEfectivo = 'dark' | 'light'

export interface PlantillaCatalogo {
    id: string
    nombre: string
}

/** Default = el panel del 2026-09-15. Editorial se distingue en tipo y acento. */
export const CATALOGO_PLANTILLAS: readonly PlantillaCatalogo[] = [
    { id: 'default', nombre: 'Default' },
    { id: 'editorial', nombre: 'Editorial' },
]

export const PLANTILLA_DEFECTO = 'default'
export const TEMA_DEFECTO: Tema = 'auto'

export function esTema(v: unknown): v is Tema {
    return TEMAS.includes(v as Tema)
}

export function idPlantilla(v: unknown): string {
    const id = typeof v === 'string' ? v : ''
    return CATALOGO_PLANTILLAS.some((p) => p.id === id) ? id : PLANTILLA_DEFECTO
}

export function temaEfectivo(tema: Tema, sistema: TemaEfectivo): TemaEfectivo {
    if (tema === 'dark' || tema === 'light') return tema
    return sistema
}

/** Default oscuro = el panel del 2026-09-15. Claro = papel Apple. */
export const FONDO_DEFAULT_DARK = '#0a0a0a'
export const FONDO_DEFAULT_LIGHT = '#f5f5f7'
export const FONDO_EDITORIAL_DARK = '#14110e'
export const FONDO_EDITORIAL_LIGHT = '#f3eee6'
export const TINTA_DEFAULT_LIGHT = '#1d1d1f'
export const SECUNDARIO_DEFAULT_LIGHT = '#6e6e73'

/** Fondo de página (theme-color / html). */
export function colorFondo(efectivo: TemaEfectivo, plantilla: string): string {
    const p = idPlantilla(plantilla)
    if (p === 'editorial') {
        return efectivo === 'dark' ? FONDO_EDITORIAL_DARK : FONDO_EDITORIAL_LIGHT
    }
    return efectivo === 'dark' ? FONDO_DEFAULT_DARK : FONDO_DEFAULT_LIGHT
}

export function aplicarApariencia(opts: {
    tema: Tema
    plantilla: string
    sistema: TemaEfectivo
    root?: HTMLElement
    themeColor?: HTMLMetaElement | null
}): { efectivo: TemaEfectivo; plantilla: string; fondo: string } {
    const efectivo = temaEfectivo(opts.tema, opts.sistema)
    const plantilla = idPlantilla(opts.plantilla)
    const fondo = colorFondo(efectivo, plantilla)
    const root = opts.root ?? (typeof document !== 'undefined' ? document.documentElement : null)
    if (root) {
        root.dataset['tema'] = efectivo
        root.dataset['plantilla'] = plantilla
        root.style.colorScheme = efectivo
    }
    const meta =
        opts.themeColor ??
        (typeof document !== 'undefined'
            ? document.querySelector('meta[name="theme-color"]')
            : null)
    if (meta) meta.setAttribute('content', fondo)
    return { efectivo, plantilla, fondo }
}
